import React, {Component} from 'react'
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {realParaNumber} from '../../util/numberUtil';
import Autorizacao from '../../security/Autorizacao';
import {PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa} from '../../security/securityContext';
import {withRouter} from 'react-router-dom';
import Moment from 'react-moment';
import selecionarEmissaoCteOs from '../../actions/cteos/selecionarEmissaoCteOs';
import { situacaoTransmissaoCteOs } from '../../util/constantsUtil';
import ReactTooltip from 'react-tooltip';

export class EmissaoCteOS extends Component {


    exibeBotaoTransmissaoEdicaoDadosNotaFiscalCteOs() {
        if (this.props.cteOS.ultimoHistoricoEmissaoCteOs == null) {
            return true;
        }
        if (this.props.cteOS.ultimoHistoricoEmissaoCteOs != null
            && this.props.cteOS.ultimoHistoricoEmissaoCteOs.situacaotransmissao.chave == situacaoTransmissaoCteOs.erro) {
            return true;
        }

        return false;
    }

    exibeBotaoCancelarNotaFiscal() {
        if (this.props.cteOS.ultimoHistoricoEmissaoCteOs == null) {
            return false;
        }

        return this.props.cteOS.ultimoHistoricoEmissaoCteOs.situacaotransmissao.chave === situacaoTransmissaoCteOs.sucesso &&
            (this.props.cteOS.ultimoHistoricoEventoCte == null ||
                this.props.cteOS.ultimoHistoricoEventoCte.situacaotransmissao.chave === situacaoTransmissaoCteOs.erro);


    }

    exibeBotaoImprimirNota() {
        if (this.props.cteOS.ultimoHistoricoEmissaoCteOs != null
            && this.props.cteOS.ultimoHistoricoEmissaoCteOs.situacaotransmissao.chave == situacaoTransmissaoCteOs.sucesso) {
            return true;
        }

        return false;
    }

    exibirIconeMotivoErro (historico) {
        if (historico != null
                && historico.situacaotransmissao.chave === situacaoTransmissaoCteOs.erro) {

            const motivo = historico.motivo ? historico.motivo.replace(/Rejeição: /, '') : ''

            return <span className="align-self-center tooltip-info">
                    <a data-tip data-for={`cte-os-${historico.id}-${this.props.cteOS.id}`}>
                        <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
                    </a>
                    <div className="tooltip-ut">
                        <ReactTooltip className="tooltip-ut" id={`cte-os-${historico.id}-${this.props.cteOS.id}`}
                                    type="dark" effect="solid">
                        <div className="row">{motivo}</div>
                        </ReactTooltip>
                    </div>
                    </span>
        }

        return ''
    }

    getSituacaoBadgeClass(historico) {
        if (!historico) return 'vx-gp-badge--default';
        const chave = historico.situacaotransmissao.chave;
        if (chave === 'SUCESSO') return 'vx-gp-badge--aprovado';
        if (chave === 'ERRO') return 'vx-gp-badge--cancelado';
        return 'vx-gp-badge--pendente';
    }

    render() {
        const { cteOS } = this.props;
        const tomadorNome = cteOS.tomador
            ? (cteOS.tomador.nomePessoa || cteOS.tomador.nomeFantasia || '-')
            : '-';
        const valor = realParaNumber(cteOS.valorServico).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

        return (
            <div className="vx-gp-row">
                <div className="vx-gp-row-main vx-gp-row-main--cteos">
                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">ID</span>
                        <span className="vx-gp-field-value">#{cteOS.id}</span>
                    </div>
                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Emissão</span>
                        <span className="vx-gp-field-value">
                            {cteOS.dataEmissao ? <Moment format="DD/MM/YYYY">{cteOS.dataEmissao}</Moment> : '-'}
                        </span>
                    </div>
                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Tomador</span>
                        <span className="vx-gp-field-value">{tomadorNome}</span>
                    </div>
                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Serviço</span>
                        <span className="vx-gp-field-value">{cteOS.descricaoServico || '-'}</span>
                    </div>
                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Série</span>
                        <span className="vx-gp-field-value">{cteOS.serie || '-'}</span>
                    </div>
                    <div className="vx-gp-field vx-gp-field--price">
                        <span className="vx-gp-field-label">Valor</span>
                        <span className="vx-gp-field-value">{valor}</span>
                    </div>
                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Status CT-e OS</span>
                        {cteOS.ultimoHistoricoEmissaoCteOs == null
                            ? <span className="vx-gp-badge vx-gp-badge--default">Em preenchimento</span>
                            : <span className={`vx-gp-badge ${this.getSituacaoBadgeClass(cteOS.ultimoHistoricoEmissaoCteOs)}`}>
                                {cteOS.ultimoHistoricoEmissaoCteOs.situacaotransmissao.valor}
                                {this.exibirIconeMotivoErro(cteOS.ultimoHistoricoEmissaoCteOs)}
                              </span>
                        }
                    </div>
                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Cancelamento</span>
                        {cteOS.ultimoHistoricoEventoCte == null
                            ? <span className="vx-gp-field-sub">-</span>
                            : <span className={`vx-gp-badge ${this.getSituacaoBadgeClass(cteOS.ultimoHistoricoEventoCte)}`}>
                                {cteOS.ultimoHistoricoEventoCte.situacaotransmissao.valor}
                                {this.exibirIconeMotivoErro(cteOS.ultimoHistoricoEventoCte)}
                              </span>
                        }
                    </div>
                    <div className="vx-gp-field--actions">
                        <div className="dropdown">
                            <button className="vx-gp-action-btn" type="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="material-icons">more_vert</i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-right">
                                {this.exibeBotaoTransmissaoEdicaoDadosNotaFiscalCteOs() &&
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="dropdown-item"
                                           data-toggle="modal"
                                           data-target="#modalConfirmacaoTransmissaoCteOs"
                                           onClick={() => this.props.selecionarEmissaoCteOs(cteOS)}>
                                            <i className="material-icons mr-2" style={{fontSize:16}}>send</i>
                                            Transmitir CT-e OS
                                        </a>
                                    </Autorizacao>}
                                {this.exibeBotaoCancelarNotaFiscal() &&
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="dropdown-item"
                                           data-toggle="modal"
                                           data-target="#modalCancelamentoCteOs"
                                           onClick={() => this.props.selecionarEmissaoCteOs(cteOS)}>
                                            <i className="material-icons mr-2" style={{fontSize:16}}>cancel</i>
                                            Cancelar Nota Fiscal
                                        </a>
                                    </Autorizacao>}
                                {this.exibeBotaoImprimirNota() &&
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="dropdown-item" onClick={() => this.props.history.push(`/nota-fiscal-cte-os?cteos=${cteOS.id}`)}>
                                            <i className="material-icons mr-2" style={{fontSize:16}}>print</i>
                                            Imprimir Nota
                                        </a>
                                    </Autorizacao>}
                                {this.exibeBotaoTransmissaoEdicaoDadosNotaFiscalCteOs() &&
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="dropdown-item" onClick={() => {
                                            this.props.selecionarEmissaoCteOs(cteOS);
                                            this.props.history.push('/painel-cadastro-cte-os');
                                        }}>
                                            <i className="material-icons mr-2" style={{fontSize:16}}>edit</i>
                                            Editar Dados da Nota
                                        </a>
                                    </Autorizacao>}
                                {!this.exibeBotaoTransmissaoEdicaoDadosNotaFiscalCteOs() &&
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.empresaSelecionada.id),
                                        getAdminEmpresa(this.props.empresaSelecionada.id),
                                        getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                                        <a className="dropdown-item" onClick={() => {
                                            this.props.selecionarEmissaoCteOs(cteOS);
                                            this.props.history.push('/painel-cadastro-cte-os');
                                        }}>
                                            <i className="material-icons mr-2" style={{fontSize:16}}>visibility</i>
                                            Visualizar Dados da Nota
                                        </a>
                                    </Autorizacao>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada
    });

export default withRouter(connect(mapStateToProps,
    {
        selecionarEmissaoCteOs
    })(reduxForm({
        form: 'formularioPainelCteOS'
    })(EmissaoCteOS)))